import { Injectable, inject } from '@angular/core';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { TimelineCommonOperationsService } from '../../services/timeline-common-operations.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { TimelineStaysSuggestionService } from '@wilson/shift-timeline/state';

@Injectable()
export class TimelineUserRowDropZoneCommonOperationsService {
  private dragAndDropModeService = inject(DragAndDropModeService);
  private createNewViaDragAndDropService = inject(
    CreateNewViaDragAndDropService,
  );
  private timelineCommonOperationsService = inject(
    TimelineCommonOperationsService,
  );
  private nzMessageService = inject(NzMessageService);
  private translateService = inject(TranslateService);
  protected timelineStaysSuggestionService = inject(
    TimelineStaysSuggestionService,
  );

  prepareForNewQuickActivityShiftCreation(id: string): void {
    this.createNewViaDragAndDropService.addUpdatingId(id);
    this.createNewViaDragAndDropService.setNewActivityQuickActionCardDraggable(
      false,
    );
    this.dragAndDropModeService.setHorizontalDemarcatorRange({
      left: null,
      right: null,
      shiftDuration: null,
      adjustmentNeeded: true,
    });
  }

  setDragCardVisibleAndRefreshShiftValidations(id: string | undefined): void {
    this.createNewViaDragAndDropService.setNewActivityQuickActionCardDraggable(
      true,
    );
    if (id) {
      this.timelineCommonOperationsService.updateProductivityAndKpisOfUsers([
        id,
      ]);
      this.timelineStaysSuggestionService.refreshStaysDataForSpecifiedUsers([
        id,
      ]);
    }
  }

  handleQuickShiftErrorCleanup(id: string): void {
    this.createNewViaDragAndDropService.setQuickShiftDraggable(true);
    this.nzMessageService.error(
      this.translateService.instant('general.something_went_wrong'),
    );
    this.createNewViaDragAndDropService.removeUpdatingId(id);
  }
}
